import HTMLContent from '@finn/auto-ui/ui-modules/HTMLContent';
import { useMemo } from 'react';

// this component automatically converts list items in the content to links
// sort of mini table of contents
export const Autolink = ({ content }: { content?: string }) => {
  const adjustedContent = useMemo(() => {
    if (typeof window !== 'object') {
      return content || '';
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    doc.querySelectorAll('li').forEach((li) => {
      const text = li.textContent.trim();
      const slug =
        text
          ?.toLowerCase()
          ?.replace(/[^A-Za-z]/g, '')
          ?.toLowerCase() || '';
      const a = doc.createElement('a');
      a.className = '!no-underline border-b border-black';
      a.href = `#${slug}`;
      a.textContent = text;

      li.replaceChildren(a);
    });

    return doc.body.innerHTML;
  }, [content]);

  return (
    <HTMLContent
      className="-mt-6 md:-mt-14"
      centered={false}
      content={adjustedContent}
    />
  );
};
